import * as actions from './actions';
import { ICatNoteDto } from '@shared/service-proxies/service-proxies';

export interface State {
    notes: ICatNoteDto[];
}

export const initialState: State = {
    notes: undefined
};

export function reducer(
    state = initialState,
    action: actions.Actions
): State {
    switch (action.type) {
        case actions.LOAD_NOTES_SUCCEEDED:
            return {
                ...state,
                notes: action.notes
            };
        case actions.ADD_NOTE_SUCCEEDED:
            return {
                ...state,
                notes: (state.notes || []).concat(action.note)
            };
        case actions.RESET:
            return initialState;
        default: {
            return state;
        }
    }
}

/**
 * Because the data structure is defined within the reducer it is optimal to
 * locate our selector functions at this level. If store is to be thought of
 * as a database, and reducers the tables, selectors can be considered the
 * queries into said database. Remember to keep your selectors small and
 * focused so they can be combined and composed to fit each particular
 * use-case.
 */

export const getNotes = (state: State): ICatNoteDto[] => state.notes;
